<template>
  <LoadingState v-if="siteStatus.isLoading" :size="50" />
  <div v-else>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 mb-4">
            <LocalMailDelivery :site="site" :loading="loadingLocalMailInfo" />
          </div>
          <div class="col-md-6 mb-4">
            <WebMail :loading="siteStatus.isLoading" :site="site" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-2 mb-4">
        <EmailBoxesTable
          :email-boxes="emailBoxes"
          :local-mail-delivery-enabled="!!localMailDeliveryEnabled"
          :site="site"
          :site-status="siteStatus"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-4">
        <EmailAliasesTable :email-aliases="emailAliases" :site="site" :site-status="siteStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import EmailAliasesTable from "@/components/smart/tables/EmailAliasesTable";
import EmailBoxesTable from "@/components/smart/tables/EmailBoxesTable";
import LoadingState from "@/components/display/LoadingState";
import LocalMailDelivery from "@/components/smart/cards/LocalMailDelivery";
import store from "@/store";
import WebMail from "@/components/smart/cards/WebMail";

export default {
  name: "PlanEmailPage",
  components: { LocalMailDelivery, WebMail, EmailBoxesTable, EmailAliasesTable, LoadingState },
  setup() {
    const site = computed(() => store.getters["plans/getPrimarySite"]);
    const emailBoxes = computed(() => store.state.emailBoxes);
    const emailAliases = computed(() => store.state.emailAliases);

    const siteStatus = computed(() => store.getters["plans/getPrimarySiteStatus"]);
    const loadingLocalMailInfo = ref(true);
    const localMailDeliveryEnabled = computed(
      () => store.state.emailBoxes.localMailDeliveryEnabled
    );

    onMounted(() => {
      // get all the email boxes and aliases for this site
      store.dispatch("emailBoxes/getList", { siteId: site.value.id });
      store.dispatch("emailAliases/getList", { siteId: site.value.id });

      // get whether local mail delivery is currently enabled for this site or not
      store
        .dispatch("emailBoxes/getLocalMailDeliveryInfo", {
          siteId: site.value.id,
          domain: site.value.domain,
        })
        .then((enabled) => {
          // keep track of this for handling transition states
          store.dispatch("emailBoxes/setLocalMailDelivery", enabled);
        })
        .finally(() => {
          loadingLocalMailInfo.value = false;
        });
    });

    return {
      site,
      siteStatus,
      loadingLocalMailInfo,
      emailBoxes,
      emailAliases,
      localMailDeliveryEnabled,
    };
  },
};
</script>
